module.exports = __webpack_public_path__ + "img/DSC_4536.d9f8e77c.jpg";